import { render, staticRenderFns } from "./ComparisonSalesProfit.vue?vue&type=template&id=6a33f819&scoped=true&"
import script from "./ComparisonSalesProfit.vue?vue&type=script&lang=js&"
export * from "./ComparisonSalesProfit.vue?vue&type=script&lang=js&"
import style0 from "./ComparisonSalesProfit.vue?vue&type=style&index=0&id=6a33f819&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a33f819",
  null
  
)

export default component.exports